(function() {
  'use strict';
  angular.module('benefits')
  .service('planFormat', function() {
    var planAccumFilter = function(data) {
      var returnList = [];
      var planType = data.planType;
      if(data.maximum ) {
        var maxBenefitPeriod = {
          name: 'Maximums - Benefit Period',
          inNetworkIndividual: data.maximum.benefitPeriod.individual.amountInNetwork,
          inNetworkFamily: data.maximum.benefitPeriod.family.amountInNetwork,
          outNetworkIndividual: data.maximum.benefitPeriod.individual.amountOutNetwork,
          outNetworkFamily: data.maximum.benefitPeriod.family.amountOutNetwork
        };
        var maxBenefitRemaining = {
          name: 'Maximums - Benefit Period Remaining',
          inNetworkIndividual: data.maximum.benefitPeriod.individual.remainingInNetwork,
          inNetworkFamily: data.maximum.benefitPeriod.family.remainingInNetwork,
          outNetworkIndividual: data.maximum.benefitPeriod.individual.remainingOutNetwork,
          outNetworkFamily: data.maximum.benefitPeriod.family.remainingOutNetwork
        };
        var maxLifePeriod = {
          name: 'Maximums - Lifetime',
          inNetworkIndividual: data.maximum.lifetime.individual.amountInNetwork,
          inNetworkFamily: data.maximum.lifetime.family.amountInNetwork,
          outNetworkIndividual: data.maximum.lifetime.individual.amountOutNetwork,
          outNetworkFamily: data.maximum.lifetime.family.amountOutNetwork
        };
        var maxLifeRemaining = {
          name: 'Maximums - Lifetime Remaining',
          inNetworkIndividual: data.maximum.lifetime.individual.remainingInNetwork,
          inNetworkFamily: data.maximum.lifetime.family.remainingInNetwork,
          outNetworkIndividual: data.maximum.lifetime.individual.remainingOutNetwork,
          outNetworkFamily: data.maximum.lifetime.family.remainingOutNetwork
        };
        returnList.push(maxBenefitPeriod, maxBenefitRemaining, maxLifePeriod, maxLifeRemaining);
      }
      if(data.deductible) {
        var deductibleBenefitPeriod = {
          name: 'Deductible - Benefit Period',
          inNetworkIndividual: data.deductible.benefitPeriod.individual.amountInNetwork,
          inNetworkFamily: data.deductible.benefitPeriod.family.amountInNetwork,
          outNetworkIndividual: data.deductible.benefitPeriod.individual.amountOutNetwork,
          outNetworkFamily: data.deductible.benefitPeriod.family.amountOutNetwork
        };
        var deductibleBenefitRemaining = {
          name: 'Deductible - Benefit Period Remaining',
          inNetworkIndividual: data.deductible.benefitPeriod.individual.remainingInNetwork,
          inNetworkFamily: data.deductible.benefitPeriod.family.remainingInNetwork,
          outNetworkIndividual: data.deductible.benefitPeriod.individual.remainingOutNetwork,
          outNetworkFamily: data.deductible.benefitPeriod.family.remainingOutNetwork
        };
        returnList.push(deductibleBenefitPeriod, deductibleBenefitRemaining);
      }
      if(data.outOfPocket) {
        var outOfPocketBenefitPeriod = {
          name: 'Out Of Pocket - Benefit Period',
          inNetworkIndividual: data.outOfPocket.benefitPeriod.individual.amountInNetwork,
          inNetworkFamily: data.outOfPocket.benefitPeriod.family.amountInNetwork,
          outNetworkIndividual: data.outOfPocket.benefitPeriod.individual.amountOutNetwork,
          outNetworkFamily: data.outOfPocket.benefitPeriod.family.amountOutNetwork
        };
        var outOfPocketBenefitRemaining= {
          name: 'Out Of Pocket - Benefit Period Remaining',
          inNetworkIndividual: data.outOfPocket.benefitPeriod.individual.remainingInNetwork,
          inNetworkFamily: data.outOfPocket.benefitPeriod.family.remainingInNetwork,
          outNetworkIndividual: data.outOfPocket.benefitPeriod.individual.remainingOutNetwork,
          outNetworkFamily: data.outOfPocket.benefitPeriod.family.remainingOutNetwork
        };
        returnList.push(outOfPocketBenefitPeriod, outOfPocketBenefitRemaining);
      }
      return returnList;
    };
    var planNameFilter = function(data) {

    };
    return  {
      planAccumFilter,
      planNameFilter
    };
  });
})();
